const columns = [
  {
    field: 'id',
    label: 'ID',
    width: '40'
  },
  {
    field: 'name',
    label: 'Nama Petugas',
    sortable: true
  },
  {
    field: 'organization.name',
    label: 'Organisasi',
    sortable: true
  },
  {
    field: 'address.subdistrict',
    label: 'Alamat',
  },
  {
    field: 'contact.mobilePhone',
    label: 'Nomor Handphone',
  },
  {
    field: 'notification',
    label: 'Notifikasi'
  },
  {
    field: 'notification',
    label: 'Status'
  },
  {
    field: 'action',
    label: ''
  }
]

const actionField = {
  action: '...'
}

export default {
  name: 'OfficerEntryTable',
  props: {
    items: {
      default: () => []
    }
  },
  data () {
    return {
      columns
    }
  },
  computed: {
    officers () {
      return this.items.map(i => ({...i, ...actionField}))
    }
  }
}
